import { Injectable } from '@angular/core';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { DomSanitizer } from '@angular/platform-browser';
import { switchMap } from 'rxjs/operators';
import { Observable } from 'rxjs';

import { CustomModalComponent } from '@app/shared/custom-modal/custom-modal.component';
import { ModalAddBankaccountComponent } from '@app/shared/modal/modal-add-bankaccount/modal-add-bankaccount.component';
import { ModalBankaccountEditComponent } from '@app/shared/modal/modal-bankaccount-edit/modal-bankaccount-edit.component';
import { ModalExampleIdComponent } from '@app/shared/modal/modal-example-id/modal-example-id.component';
import { ModalStpComponent } from '@app/shared/modal/modal-stp/modal-stp.component';
import { ModalAddBeneficiaryComponent } from '@app/shared/modal/modal-add-beneficiary/modal-add-beneficiary.component';
import { ModalKnowledgeRisks } from '@app/shared/modal/modal-knowledge-risks/modal-knowledge-risks.component';
import { ModalPartsOnSaleComponent } from '@app/shared/modal/modal-parts-on-sale/modal-parts-on-sale.component';
import { ModalNipComponent } from '@app/shared/modal/modal-nip/modal-nip.component';
import { ModalSetNipComponent } from '@app/shared/modal/modal-set-nip/modal-set-nip.component';
import { ModalOtpComponent } from '@app/shared/modal/modal-otp/modal-otp.component';
import { ModalVideoComponent } from '@app/shared/modal/modal-video/modal-video.component';
import { UserWithdrawComponent } from '@app/shared/user-withdraw/user-withdraw.component';
import { DeveloperWithdrawComponent } from '@app/shared/developer-withdraw/developer-withdraw.component';
import { ModalCustomComponent } from '@app/shared/modal-custom/modal-custom.component';
import { ModalViewProjectsComponent } from '@app/shared/modal/modal-view-projects/modal-view-projects.component';
import { ModalViewResourcesComponent } from '@app/shared/modal/modal-view-resources/modal-view-resources.component';

import { UserService } from '../user/user.service';
import { ModalCustomOptions, OTP_ACTION } from '@app/models';
import { BankAccount, OnSaleOffer } from '@interfaces/app';
import { ModalMfaComponent } from '@app/shared/modal/modal-mfa/modal-mfa.component';
import { ModalNotBalanceComponent } from '@app/shared/modal-not-balance/modal-not-balance.component';
import { ModalPromotionsComponent } from '@app/shared/modal/modal-promotions/modal-promotions.component';
import { ModalFiscalUpdateComponent } from '@app/shared/modal/modal-fiscal-update/modal-fiscal-update.component';
import { ModalStpPendingComponent } from '@app/shared/modal/modal-stp-pending/modal-stp-pending.component';
import { ModalVerifyPwComponent } from '@app/shared/modal/modal-verify-pw/modal-verify-pw.component';
import { ModalPurchasePartMktComponent } from '@app/shared/modal-purchase-part-mkt/modal-purchase-part-mkt.component';
import { UserDirectDebitComponent } from '@app/shared/user-direct-debit/user-direct-debit.component';
import { ModalContractDomiciliationComponent } from '@app/shared/modal/modal-contract-domiciliation/modal-contract-domiciliation.component';
import { ModalModifyAutoinvestComponent } from '@app/shared/modal/modal-modify-autoinvest/modal-modify-autoinvest.component';
import { ModalPayPerformanceComponent } from '@app/shared/modal/development/modal-pay-performance/modal-pay-performance.component';
import { ModalAcceptResourcesComponent } from '@app/shared/modal/development/modal-accept-resources/modal-accept-resources.component';
import { ModalConfirmResourcesComponent } from '@app/shared/modal/development/modal-accept-resources/modal-confirm-resources/modal-confirm-resources.component';
import { ModalConfirmAutoinvestComponent } from '@app/shared/modal/modal-confirm-autoinvest/modal-confirm-autoinvest.component';
import { GraphDomComponent } from '@app/shared/modal/user-direct-debit/graph-dom/graph-dom.component';
import { ModalConfirmDomiciliationComponent } from '@app/shared/modal/modal-confirm-domiciliation/modal-confirm-domiciliation.component';
import { ModalUploadIneComponent } from '@app/shared/modal/modal-upload-ine/modal-upload-ine.component';
import { ProfileLegalComponent } from '@app/shared/profile-legal/profile-legal/profile-legal.component';
import { ModalLogoutComponent } from '@app/shared/modal/modal-logout/modal-logout.component';


@Injectable({
   providedIn: 'root'
})
export class ModalService {

   customOptions: MatDialogConfig = {
      width: '95vw',
      maxWidth: '500px',
      autoFocus: false,
      maxHeight: '95vh'
   };

   constructor(private modal: MatDialog, private domSanit: DomSanitizer, private userServ: UserService) { }

   /** @deprecated VERSIÓN ANTERIOR DE MODAL */
   customModal<T = any>(config: ModalCustomOptions) {
      const modal = this.modal.open<CustomModalComponent, any, T>(CustomModalComponent, this.customOptions);
      modal.componentInstance.config = config;

      return modal;
   }

   /** Versión actual de modal */
   modalCustom<T = any>(config: ModalCustomOptions) {
      const modal = this.modal.open<ModalCustomComponent, any, T>(ModalCustomComponent, {
         panelClass: 'mnf-modal-container',
         ...this.customOptions
      });
      modal.componentInstance.config = config;

      return modal;
   }


   /** Modal STP actual */
   openModalStpPending(regProm?: string) {
      const modal = this.modal.open(ModalStpPendingComponent, {
         panelClass: 'mnf-modal-container',
         ...this.customOptions
      });
      modal.componentInstance.regProm = regProm;
      return modal;
   }

   openEditAccount(account: BankAccount) {
      const modal = this.modal.open(ModalBankaccountEditComponent, {
         panelClass: 'mnf-modal-container',
         ...this.customOptions
      });

      modal.componentInstance.account = account;

      return modal;
   }

   openExampleID(url: string) {
      const dial = this.modal.open(ModalExampleIdComponent, {
         width: '80vw',
         maxWidth: '600px',
         autoFocus: false,
      });

      dial.componentInstance.url = url;

      return dial;
   }

   openAddBeneficiary(limit: number, benef?: any) {
      const customOptions: MatDialogConfig = {
         panelClass: 'mnf-modal-container',
         ...this.customOptions,
         // maxHeight: '90vh',
      };

      const modal = this.modal.open(ModalAddBeneficiaryComponent, customOptions);
      modal.componentInstance.limit = limit;
      modal.componentInstance.benef = benef;

      return modal;
   }

   openAddBankAccount() {
      return this.modal.open(ModalAddBankaccountComponent, this.customOptions);
   }

   openModalModifyAutoInvest() {
      const m = this.modal.open(ModalModifyAutoinvestComponent, {
         maxWidth: '650px',
         width: '95%',
         panelClass: 'auto-height-dialog',
         height: '90vh',
         autoFocus: false,
         ariaModal: true,
      });
   }

   openSTPInfo(name: string, clabe: string) {
      const m = this.modal.open(ModalStpComponent, {
         panelClass: 'mnf-modal-container',
         width: '95vw',
         maxWidth: '500px',
         autoFocus: false,
      });
      m.componentInstance.clabe = clabe;
      m.componentInstance.name = name;
   }

   openKnowledgeRisks() {
      const customOptions: MatDialogConfig = {
         autoFocus: false,
         width: '95vw',
         maxWidth: '1000px',
         maxHeight: '90vh',
         disableClose: true
      };

      const modal = this.modal.open(ModalKnowledgeRisks, customOptions);

      return modal;
   }

   openNIP() {
      return this.modal.open(ModalNipComponent, {
         panelClass: 'mnf-modal-container',
      });
   }

   openMFA() {
      return this.modal.open(ModalMfaComponent, {
         panelClass: 'mnf-modal-container',
         width: '30%',
         minWidth: '450px',
         minHeight: '50%',
         autoFocus: true,
         disableClose: true
      });
   }

   openModalPromotions() {
      return this.modal.open(ModalPromotionsComponent, {
         panelClass: 'mnf-modal-promotions',
         width: '95%',
         maxWidth: '465px',
         height: '410px',
         autoFocus: true,
         disableClose: true
      })
   }

   openOTP(conf: { title?: string; message?: string; header?: string; } = {}) {
      const m = this.modal.open(ModalOtpComponent, {
         panelClass: 'mnf-modal-container',
         width: '30%',
         minWidth: '400px',
         minHeight: '50%',
         autoFocus: true,
         disableClose: true
      });

      m.componentInstance.config = { title: 'Código temporal', message: 'Ingresa código temporal enviado', ...conf };

      return m;
   }

   sendAndOpenModalOTP(action: OTP_ACTION, conf: { title: string; message: string; header: string }) {
      return this.userServ.sendOtp(action).pipe(switchMap(() => this.openModalOTP(conf)));
   }

   openModalOTP(conf: { title: string; message: string; header: string }) {
      return new Observable<string>(res => {
         const m = this.modal.open(ModalOtpComponent, {
            panelClass: 'mnf-modal-container',
            width: '30%',
            minWidth: '400px',
            minHeight: '50%',
            autoFocus: true,
            disableClose: true
         });
         m.componentInstance.config = conf;

         m.beforeClosed().subscribe(otpRes => {
            res.next(otpRes);
            res.complete();
         });
      })
   }

   setNip() {
      return this.modal.open<ModalSetNipComponent, boolean>(ModalSetNipComponent, {
         width: '95vw',
         maxWidth: '500px',
         autoFocus: false,
         minHeight: '185px',
         panelClass: 'px-0',
      });
   }

   openPartsOnSale() {
      return this.modal.open(ModalPartsOnSaleComponent, {
         panelClass: 'resale-modal',
         width: '95%',
         maxWidth: '750px',
         height: '80%',
         autoFocus: false
      });
   }

   openUserWithdraw(balance: number) {
      const m = this.modal.open(UserWithdrawComponent, {
         panelClass: 'mnf-modal-container',
         width: '95vw',
         maxWidth: '450px',
         autoFocus: false
      });

      m.componentInstance.balance = balance;
      return m;
   }

   openDeveloperWithdraw(balance: number) {
      const m = this.modal.open(DeveloperWithdrawComponent, {
         panelClass: ['mnf-modal-container', 'developer-withdraw-modal'],
         width: '95vw',
         maxWidth: '550px',
         maxHeight: '90vh',
         autoFocus: false
      });

      m.componentInstance.balance = balance;
      return m;
   }

   openUserDirectDebit() {
      const m = this.modal.open(UserDirectDebitComponent, {
         panelClass: 'mnf-modal-container',
         width: '95vw',
         maxWidth: '900px',
         height: '85vh',
         maxHeight: '850px',
         autoFocus: false,
      });

      return m;
   }

   openContractDomiciliation(frecuency: any, bankName: string, clabe: string, amount: number, user: any, typePlan: boolean, months: number, idBank: string) {
      const m = this.modal.open(ModalContractDomiciliationComponent, {
         panelClass: 'mnf-modal-contract',
         width: '95vw',
         maxWidth: '800px',
         autoFocus: false,
      });

      m.componentInstance.frecuency = frecuency;
      m.componentInstance.bankName = bankName;
      m.componentInstance.clabe = clabe;
      m.componentInstance.amount = amount;
      m.componentInstance.user = user;
      m.componentInstance.typePlan = typePlan;
      m.componentInstance.months = months;
      m.componentInstance.idBank = idBank;

   }

   openVideoModal(videoUrl: string, isFrame?: boolean) {
      const modal = this.modal.open(ModalVideoComponent, {
         width: '95%',
         maxWidth: '750px',
         //height: '50%',
         autoFocus: false,
         panelClass: 'p-0'
      });

      modal.componentInstance.isFrame = isFrame;
      modal.componentInstance.videoUrl = this.domSanit.bypassSecurityTrustResourceUrl(videoUrl);
   }

   openModalViewProjects(projects: any) {
      const modal = this.modal.open(ModalViewProjectsComponent, {
         width: '95%',
         maxWidth: '850px',
         height: '90%',
         panelClass: 'bg-eee',
         autoFocus: false
      });
      modal.componentInstance.actualProjects = projects;
   }

   openModalViewResources(idProject: string, idApplicant?: string) {
      const modal = this.modal.open(ModalViewResourcesComponent, {
         width: '85%',
         maxWidth: '600px',
         height: '75%',
      })
      modal.componentInstance.idApplicant = idApplicant;
      modal.componentInstance.idProject = idProject;
   }

   openModalEnoughBalance(balanceNeeded: number, parts: number, devName: string) {
      const modal = this.modal.open(ModalNotBalanceComponent, {
         panelClass: 'mnf-modal-container',
         width: '100%',
         maxWidth: '600px',
         maxHeight: '95vh',
         autoFocus: false,
      });
      modal.componentInstance.balanceNeeded = balanceNeeded;
      modal.componentInstance.participationsToPurchase = parts;
      modal.componentInstance.devName = devName;

      return modal;
   }

   openModalUpdateCFDI() {
      return this.modal.open(ModalFiscalUpdateComponent, {
         panelClass: 'mnf-modal-container',
         width: '60vw',
         maxWidth: '600px',
         autoFocus: false,
      });
   }

   openModalViewGraph(amount: string) {
      const modal = this.modal.open(GraphDomComponent, {
         panelClass: 'mnf-modal-container',
         width: '90vw',
         maxWidth: '850px',
         height: '85vh',
         autoFocus: false,
      })

      modal.componentInstance.amount = amount;

      return modal;

   }

   /** Modal para verificar password */
   openModalVerifyPassword(email: string) {
      const m = this.modal.open(ModalVerifyPwComponent, {
         panelClass: 'mnf-modal-container',
         width: '95vw',
         maxWidth: '500px',
         autoFocus: false,
      });
      m.componentInstance.email = email;

      return m;
   }

   /** Modal para pagar rendimientos */
   openModalPayPerformance(project: any) {
      const m = this.modal.open(ModalPayPerformanceComponent, {
         panelClass: 'mnf-modal-container',
         width: '95vw',
         maxWidth: '600px',
         autoFocus: false,
      });
      m.componentInstance.project = project;
      return m;
   }

   /** Modal para aceptar recursos */
   openModalAcceptResources(projectInfo: any, projectData: any, availableAcceptResources: boolean) {
      const m = this.modal.open(ModalAcceptResourcesComponent, {
         panelClass: 'mnf-modal-container',
         width: '95vw',
         maxWidth: '700px',
         autoFocus: false,
      });
      m.componentInstance.project = projectInfo;
      m.componentInstance.withdrawData = projectData;
      m.componentInstance.availableAcceptResources = availableAcceptResources;
      return m;
   }

   openModalConfirmResources(infoAmount: any) {
      const m = this.modal.open(ModalConfirmResourcesComponent, {
         panelClass: 'mnf-modal-container',
         width: '95vw',
         maxWidth: '700px',
         autoFocus: false,
         maxHeight: '75vh'
      });
      m.componentInstance.infoAmount = infoAmount;
      return m;
   }

   /** Modal para comprar participaciones */
   openModalBuyPartMKT(
      params: {
         partsAmount: number, partsValue: number,
         commissionNet: number, commissionTax: number,
         total: number, devName: string,
         userBalance: number, partsSelectedArray: OnSaleOffer[],
      }
   ) {
      const modal = this.modal.open(ModalPurchasePartMktComponent, {
         panelClass: 'mnf-modal-container',
         width: '100vw',
         maxWidth: '600px',
         autoFocus: false,
         maxHeight: '95vh'
      });

      modal.componentInstance.partsAmount = params.partsAmount;
      modal.componentInstance.partsValue = params.partsValue;
      modal.componentInstance.commissionNet = params.commissionNet;
      modal.componentInstance.commissionTax = params.commissionTax;
      modal.componentInstance.total = params.total;
      modal.componentInstance.devName = params.devName;
      modal.componentInstance.userBalance = params.userBalance;
      modal.componentInstance.partsSelectedArray = params.partsSelectedArray;

      return modal;
   }

   /** Modal para mostar confirmación de movimiento */
   openModalConfirmMovementAutoInvest(info: any, modify: boolean) {
      const m = this.modal.open(ModalConfirmAutoinvestComponent, {
         panelClass: 'mnf-modal-container',
         width: '95vw',
         maxWidth: '500px',
         autoFocus: false,
      });
      m.componentInstance.info = info;
      m.componentInstance.modify = modify;
      return m;
   }

   /** Modal para mostar confirmación de domiciliación */
   openModalConfirmDomiciliation(info: any) {
      const m = this.modal.open(ModalConfirmDomiciliationComponent, {
         panelClass: 'mnf-modal-container',
         width: '95vw',
         maxWidth: '500px',
         autoFocus: false,
      });
      m.componentInstance.info = info;
      return m;
   }

   /** Modal para subir la INE de los inversionistas */
   openModalUploadINE() {
      const m = this.modal.open(ModalUploadIneComponent, {
         panelClass: 'mnf-modal-container',
         width: '95vw',
         maxWidth: '800px',
         autoFocus: false,
      });
      return m;
   }

   openModalOperationPerMonth() {
      const m = this.modal.open(ProfileLegalComponent, {
         panelClass: 'mnf-modal-container',
         width: '100%',
         maxWidth: '700px',
         maxHeight: '600px',
         autoFocus: false,
         disableClose: true
      })
      return m;
   }

   openModalLogout() {
      const m = this.modal.open(ModalLogoutComponent, {
         panelClass: ['logout-panel', 'auto-height-dialog'],
         hasBackdrop: true,
         width: 'auto',
         maxWidth: '90vw',
         maxHeight: '80vh',
         autoFocus: false,
      });
      return m;
   }

}
